require('@galaxy/js/habitats/website.js')

import AutoloadViews from '@galaxy/js/common/AutoloadViews';
import vueCustomElement from 'vue-custom-element';
import Vue from 'vue';

// @ugly, could not move to ^ since we could not guess the path to this habitat. Might by from /demo or of the clients project.
AutoloadViews.load('habitats.website', require.context('./website/', true, /.(js|vue)$/));
//AutoloadViews.load('components.habitats.website', require.context('./../../components/habitats/website/', true, /.(js|vue)$/));
AutoloadViews.load('habitats.website', require.context('./../../components/common/canvas/', true, /.(js|vue)$/));
AutoloadViews.load('shop::', require.context('./../../../app/Modules/Shop/Resources/', true, /.(js|vue)$/));
AutoloadViews.load('search::', require.context('./../../../app/Modules/Search/Resources/', true, /.(js|vue)$/));

// Init custom vue Components
Vue.use(vueCustomElement);

// Add custom elements
Vue.customElement('shophabitats-website-modules-shopproducts-show-productvariantselector', require('./../../../app/Modules/Shop/Resources/Components/Habitats/Website/Modules/ShopProducts/Show/ProductVariantSelector.vue').default);
